import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { media } from '../themes/theme';
import useHasReactRouterContext from '../../hooks/useHasReactRouterContext';
import { FocusStyles } from '../../styles/FocusStyles';
import { lineClampCss } from '../../helpers/lineClampCss';
import { CardFooter, CardTitle } from './shared';
const StyledCardLink = styled.a `
  text-decoration: none;
  color: inherit;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;

  /* fixes a safari shop-card issue */
  min-height: 0;
  ${FocusStyles}
`;
const CardDescription = styled.p `
  ${lineClampCss(1)}
  line-height: 1.57;
  font-size: 0.8125rem;
  font-family: ${props => props.theme.fonts.serif};
  font-weight: 300;
  width: 100%;
  text-align: center;
  transition: padding-right 0.1s;
  transition-delay: 0.75s;

  ${media.tablet `
    font-size: 0.875rem;
  `}
`;
const StyledDiv = styled.div ``;
export const CardLink = ({ 'data-trackingid': dataTrackingId, description = null, isSemanticLink = true, linkFooter = null, media, title, to, }) => {
    const hasReactRouterContext = useHasReactRouterContext();
    return (React.createElement(React.Fragment, null, isSemanticLink ? (React.createElement(React.Fragment, null, hasReactRouterContext ? (React.createElement(StyledCardLink, { as: Link, to: to, "data-testid": "card-link-react-router", "data-trackingid": dataTrackingId },
        media,
        React.createElement(CardFooter, { "data-testid": "card-link-footer" },
            React.createElement(CardTitle, { "data-testid": "card-link-title" }, title),
            React.createElement(CardDescription, { "data-testid": "card-link-description" }, description),
            linkFooter))) : (React.createElement(StyledCardLink, { href: to, "data-testid": "card-link", "data-trackingid": dataTrackingId },
        media,
        React.createElement(CardFooter, { "data-testid": "card-link-footer" },
            React.createElement(CardTitle, { "data-testid": "card-link-title" }, title),
            React.createElement(CardDescription, { "data-testid": "card-link-description" }, description),
            linkFooter))))) : (React.createElement(React.Fragment, null,
        React.createElement(StyledCardLink, { as: StyledDiv, to: to, "data-testid": "card-link-div", "data-trackingid": dataTrackingId },
            media,
            React.createElement(CardFooter, { "data-testid": "card-link-footer" },
                React.createElement(CardTitle, { "data-testid": "card-link-title" }, title),
                React.createElement(CardDescription, { "data-testid": "card-link-description" }, description),
                linkFooter))))));
};
